

export function LoadingGif() {
    return (
        <div>
            <div className="loading-overlay d-flex justify-content-center align-items-center">
                <img className="imgLoading" src={`${process.env.REACT_APP_PUBLIC_URL}imagens/loading.svg`} alt="Loading" />
            </div>
        </div>
    );
}